const waitFor = (milliseconds) => {
  const newWait = new Promise((resolve) => {
    setTimeout(resolve, milliseconds);
  });
  return newWait;
};

export default waitFor;



// WEBPACK FOOTER //
// ./src/services/helpers.js